import { IconButton, styled } from '@mui/material';
export const NavIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.disabled,
    ':hover': {
        color: theme.palette.text.muted,
    },
}));
